module.exports = __webpack_public_path__ + "static/media/fablix.55051227.png";